import { useQuery } from "@tanstack/react-query";
import cookiesHelper from "../../helpers/cookies";

import { IJobApplicationListItem } from "../../interfaces/services"

import api from "../../services";


const useGetTopJobApplications = () => {
    const queryFn = async (): Promise<IJobApplicationListItem[]> => {
        const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`
        const res = await api.get('misc/top-job-applications');
        return res.data;
    };

    return useQuery({
        queryKey: ['top_job_applications'],
        queryFn,
        retry: false,
    });
}

export default useGetTopJobApplications;
